export default __webpack_public_path__ + "static/media/hockey-canada-logo.076c572f.svg";